(() => {
  const moneyFallback = (cents) => {
    const amount = Number(cents || 0) / 100;
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD'
    }).format(amount);
  };

  const normalizeText = (value) => (value || '').replace(/\s+/g, ' ').trim();

  function changeImage(root, control) {
    const image = root.querySelector('.rv-shrine-main-image');
    if (!image || !control) return;

    if (control.dataset.src) image.src = control.dataset.src;
    if (control.dataset.srcset) image.srcset = control.dataset.srcset;
    if (control.dataset.alt) image.alt = control.dataset.alt;

    const index = control.dataset.index;
    root.querySelectorAll('[data-rv-thumb], [data-rv-dot]').forEach((item) => {
      const active = item.dataset.index === index;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

  }

  function initGallery(root) {
    const controls = Array.from(root.querySelectorAll('[data-rv-dot]'));
    const allControls = Array.from(root.querySelectorAll('[data-rv-thumb], [data-rv-dot]'));
    const mobileCarousel = root.querySelector('[data-rv-mobile-carousel]');

    const currentIndex = () => {
      const active = controls.findIndex((item) => item.classList.contains('is-active'));
      return active >= 0 ? active : 0;
    };

    allControls.forEach((control) => {
      control.addEventListener('click', () => {
        changeImage(root, control);

        if (mobileCarousel && control.matches('[data-rv-dot]')) {
          const index = Number(control.dataset.index || 0);
          const left = index * mobileCarousel.clientWidth;
          try {
            mobileCarousel.scrollTo({ left, behavior: 'smooth' });
          } catch (_) {
            mobileCarousel.scrollLeft = left;
          }
        }
      });
    });

    if (mobileCarousel && controls.length > 1) {
      let scrollFrame = 0;
      mobileCarousel.addEventListener('scroll', () => {
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          const slideWidth = mobileCarousel.clientWidth;
          if (!slideWidth) return;
          const index = Math.max(0, Math.min(controls.length - 1, Math.round(mobileCarousel.scrollLeft / slideWidth)));
          if (index !== currentIndex()) changeImage(root, controls[index]);
        });
      }, { passive: true });
    }

    const open = root.querySelector('[data-rv-open-image]');
    const modal = root.querySelector('[data-rv-lightbox]');
    const close = root.querySelector('[data-rv-close-image]');
    const lightboxImage = root.querySelector('[data-rv-lightbox-image]');
    const mainImage = root.querySelector('.rv-shrine-main-image');
    if (!open || !modal || !close || !lightboxImage || !mainImage) return;

    const closeModal = () => {
      modal.hidden = true;
      document.documentElement.style.removeProperty('overflow');
      open.focus();
    };

    open.addEventListener('click', (event) => {
      lightboxImage.src = mainImage.currentSrc || mainImage.src;
      lightboxImage.alt = mainImage.alt;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      close.focus();
    });
    close.addEventListener('click', closeModal);
    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  function initQuantity(root) {
    const input = root.querySelector('[data-rv-quantity]');
    const stickyInput = root.querySelector('[data-rv-sticky-quantity]');
    const count = root.querySelector('[data-rv-sticky-count]');
    if (!input) return;
    const sync = () => {
      const minimum = Number(input.min || 1);
      const maximum = input.max ? Number(input.max) : Infinity;
      const value = Math.min(maximum, Math.max(minimum, parseInt(input.value || '1', 10) || minimum));
      input.value = value;
      if (stickyInput) {
        stickyInput.value = value;
        stickyInput.min = input.min || '1';
        if (input.max) stickyInput.max = input.max;
        else stickyInput.removeAttribute('max');
      }
      if (count) count.textContent = '× ' + value;
    };
    const set = (value) => {
      input.value = value;
      sync();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    root.querySelectorAll('[data-rv-minus], [data-rv-sticky-minus]').forEach(button => button.addEventListener('click', () => set(Number(input.value) - 1)));
    root.querySelectorAll('[data-rv-plus], [data-rv-sticky-plus]').forEach(button => button.addEventListener('click', () => set(Number(input.value) + 1)));
    input.addEventListener('input', sync);
    input.addEventListener('change', sync);
    stickyInput?.addEventListener('change', () => set(stickyInput.value));
    sync();
  }

  function getVariants(root) {
    const node = root.querySelector('[data-rv-variant-json]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]');
    } catch (_) {
      return [];
    }
  }

  function updateVariantUI(root, variant) {
    if (!variant) return;
    const idInput = root.querySelector('[data-rv-variant-id]');
    if (idInput) idInput.value = variant.id;

    const price = root.querySelector('[data-rv-price]');
    const stickyPrice = root.querySelector('[data-rv-sticky-price]');
    const stickyCompare = root.querySelector('[data-rv-sticky-compare-price]');
    const compare = root.querySelector('[data-rv-compare-price]');
    const badge = root.querySelector('[data-rv-sale-badge]');
    const mainAtc = root.querySelector('[data-rv-main-atc]');
    const stickyAtc = root.querySelector('[data-rv-sticky-add]');

    const formattedPrice = moneyFallback(variant.price);
    if (price) price.textContent = formattedPrice;
    if (stickyPrice) stickyPrice.textContent = formattedPrice;

    const hasCompare = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
    if (compare) {
      compare.textContent = hasCompare ? moneyFallback(variant.compare_at_price) : '';
      compare.classList.toggle('is-hidden', !hasCompare);
    }
    if (stickyCompare) {
      stickyCompare.textContent = hasCompare ? moneyFallback(variant.compare_at_price) : '';
      stickyCompare.classList.toggle('is-hidden', !hasCompare);
    }
    if (badge) {
      const percentage = hasCompare
        ? Math.round((Number(variant.compare_at_price) - Number(variant.price)) * 100 / Number(variant.compare_at_price))
        : 0;
      badge.textContent = hasCompare ? 'SAVE ' + String(percentage) + '%' : '';
      badge.classList.toggle('is-hidden', !hasCompare);
    }

    [mainAtc, stickyAtc].forEach((button) => {
      if (!button) return;
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
    });
  }

  function initVariants(root) {
    const selectors = Array.from(root.querySelectorAll('[data-rv-option]'));
    if (!selectors.length) return;
    const variants = getVariants(root);

    const selectVariant = () => {
      const options = selectors.map((select) => select.value);
      const variant = variants.find((item) => Array.isArray(item.options) && item.options.every((value, index) => value === options[index]));
      if (variant) updateVariantUI(root, variant);
    };

    selectors.forEach((select) => select.addEventListener('change', selectVariant));
    selectVariant();
  }

  function extractSpecPairs(source) {
    const pairs = [];
    const seen = new Set();
    const add = (key, value) => {
      const normalizedKey = normalizeText(key).replace(/[:：]\s*$/, '');
      const normalizedValue = normalizeText(value).replace(/^[:：]\s*/, '');
      const fingerprint = normalizedKey.toLowerCase();
      if (!normalizedKey || !normalizedValue || normalizedKey.toLowerCase() === normalizedValue.toLowerCase() || seen.has(fingerprint)) return;
      seen.add(fingerprint);
      pairs.push([normalizedKey, normalizedValue]);
    };

    source.querySelectorAll('tr').forEach((row) => {
      const cells = Array.from(row.querySelectorAll(':scope > th, :scope > td'));
      if (cells.length >= 2) add(cells[0].textContent, cells.slice(1).map((el) => el.textContent).join(' '));
    });

    source.querySelectorAll('.row-m4GA').forEach((row) => {
      const text = normalizeText(row.textContent);
      const match = text.match(/^([^:：]{2,45})[:：]\s*(.+)$/);
      if (match) {
        add(match[1], match[2]);
        return;
      }
      const children = Array.from(row.children).filter((el) => normalizeText(el.textContent));
      if (children.length >= 2) add(children[0].textContent, children.slice(1).map((el) => el.textContent).join(' '));
    });

    source.querySelectorAll('dt').forEach((dt) => {
      const dd = dt.nextElementSibling;
      if (dd && dd.tagName?.toLowerCase() === 'dd') add(dt.textContent, dd.textContent);
    });

    if (!pairs.length) {
      source.querySelectorAll('p').forEach((paragraph) => {
        const text = normalizeText(paragraph.textContent);
        const match = text.match(/^([^:]{2,45}):\s*(.+)$/);
        if (match) add(match[1], match[2]);
      });
    }
    return pairs;
  }

  function initSpecifications(root) {
    const source = root.querySelector('[data-rv-spec-source]');
    const section = root.querySelector('[data-rv-specifications]');
    const target = root.querySelector('[data-rv-specification-rows]');
    const fallback = root.querySelector('[data-rv-specification-fallback]');
    if (!source || !section || !target || !fallback) return;

    const pairs = extractSpecPairs(source);
    const acceptedLabels = {
      year: 'Year',
      series: 'Series',
      'mint mark': 'Mint Mark',
      'friedberg number': 'Friedberg Number',
      signatures: 'Signatures',
      format: 'Format',
      'grading service': 'Grading Service',
      composition: 'Composition',
      quantity: 'Quantity',
      'precious metal content': 'Precious Metal Content',
      condition: 'Condition',
      grade: 'Condition',
      'ira approved': 'IRA Approved',
      'ira eligible': 'IRA Approved',
      finish: 'Finish',
      purity: 'Purity',
      denomination: 'Denomination',
      'metal content': 'Metal Content',
      metal: 'Metal Content',
      'actual weight': 'Actual Weight',
      weight: 'Actual Weight',
      'gross weight': 'Gross Weight',
      diameter: 'Diameter',
      thickness: 'Thickness',
      origin: 'Origin',
      'country of origin': 'Origin',
      mint: 'Mint/Brand',
      brand: 'Mint/Brand',
      'mint brand': 'Mint/Brand',
      'mint/brand': 'Mint/Brand'
    };

    const displayed = [];
    const used = new Set();
    pairs.forEach(([key, value]) => {
      const normalizedKey = normalizeText(key).toLowerCase().replace(/[._-]+/g, ' ');
      const label = acceptedLabels[normalizedKey];
      if (!label || used.has(label)) return;
      used.add(label);
      displayed.push([label, value]);
    });

    const hasProofFinish = displayed.some(([key, value]) => key === 'Finish' && value.toLowerCase() === 'proof');
    if (hasProofFinish) {
      const condition = displayed.find(([key]) => key === 'Condition');
      if (condition && /^(bu|brilliant uncirculated)$/i.test(condition[1])) condition[1] = 'Proof';
    }
    const finalPairs = displayed.length >= 2 ? displayed : pairs.slice(0, 14);
    section.hidden = false;

    if (!finalPairs.length) {
      target.hidden = true;
      fallback.hidden = false;
      return;
    }

    const fragment = document.createDocumentFragment();
    finalPairs.forEach(([key, value]) => {
      const row = document.createElement('div');
      const label = document.createElement('div');
      const rowValue = document.createElement('div');
      row.className = 'rv-shrine-specification-row';
      row.setAttribute('role', 'row');
      label.className = 'rv-shrine-specification-label';
      label.setAttribute('role', 'cell');
      label.textContent = key;
      rowValue.className = 'rv-shrine-specification-value';
      rowValue.setAttribute('role', 'cell');
      rowValue.textContent = value;
      row.append(label, rowValue);
      fragment.appendChild(row);
    });

    target.innerHTML = '';
    target.appendChild(fragment);
    target.hidden = false;
    fallback.hidden = true;
  }

  function initStickyAtc(root) {
    const mainAtc = root.querySelector('[data-rv-main-atc]');
    const stickyBar = root.querySelector('[data-rv-sticky-atc]');
    if (!mainAtc || !stickyBar || !('IntersectionObserver' in window)) return;

    const footer = document.querySelector('.rv-footer') || document.querySelector('footer');
    let mainAtcPassed = false;
    let footerVisible = false;

    const setStickyVisible = (visible) => {
      stickyBar.hidden = !visible;
      document.documentElement.classList.toggle('rv-sticky-atc-visible', visible);
    };

    const syncStickyVisibility = () => setStickyVisible(mainAtcPassed && !footerVisible);

    setStickyVisible(false);

    const mainAtcObserver = new IntersectionObserver((entries) => {
      const entry = entries[0];
      mainAtcPassed = entry.boundingClientRect.top < 0 && !entry.isIntersecting;
      syncStickyVisibility();
    }, { threshold: 0 });
    mainAtcObserver.observe(mainAtc);

    if (footer) {
      const footerObserver = new IntersectionObserver((entries) => {
        footerVisible = entries[0].isIntersecting;
        syncStickyVisibility();
      }, { threshold: 0 });
      footerObserver.observe(footer);
    }
  }

  function init(root) {
    if (!root || root.dataset.rvInitialized === 'true') return;
    root.dataset.rvInitialized = 'true';
    initGallery(root);
    initQuantity(root);
    initVariants(root);
    initSpecifications(root);
    initStickyAtc(root);
  }

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-rv-product]').forEach(init);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
